/**
 * The one OPINK guard code a design save can raise
 * (`MailjetVariableHelper.EnsurePreferenceCenterLink`). Typed against `ContentAuditRuleId` so a
 * rename of the audit rule breaks here at compile time rather than silently falling through to the
 * generic fallback toast.
 */
export const MISSING_PREFERENCES_LINK = "MISSING_PREFERENCES_LINK";
/**
 * `errorCode` → i18n key for the design-save catch sites (R70), shared by the template editor and
 * the action-content editor so the two cannot describe the same refusal differently. The publish
 * catch site reuses it defensively: `PublishTemplateCommand` enforces no compliance link of its
 * own, so there the map never matches and the fallback key wins.
 */
export const DESIGN_SAVE_ERROR_OVERRIDES = {
    [MISSING_PREFERENCES_LINK]: "templating.errors.missingPreferencesLink",
};
